// assets
//import { IconDashboard } from '@tabler/icons';
import { Home as IconDashboard} from "@mui/icons-material";

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    type: 'group',
    alwaysVisible: true,
    children: [
        {
            id: 'default',
            title: 'Inicio',
            type: 'item',
            alwaysVisible: true,
            url: '/dashboard/default',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export default dashboard;
